module.exports = __webpack_public_path__ + "static/media/16UNODC10.e825d6fe.jpg";